import { useEffect } from "react";
import { WVCEA_EMAIL } from "./help-content";
import { PRIVACY_SECTIONS, PRIVACY_UPDATED } from "./privacy-content";
import { associationPresentation } from "./association-presentation";

/**
 * The privacy policy, inside the application rather than only on a website.
 *
 * Both stores require the address before they will take a submission, and Apple's account
 * deletion rule expects retention to be disclosed somewhere. This is that somewhere, which
 * is what lets the deletion screen say two sentences instead of six.
 *
 * Reachable without signing in, on purpose. Somebody deciding whether to make an account
 * is exactly the person who wants to read it.
 */
export function PrivacyPage({ eventName }: { eventName: string }) {
  const presentation = associationPresentation();
  useEffect(() => {
    document.title = `Privacy · ${eventName}`;
  }, [eventName]);

  if (!presentation.wvcea) return <div className="page privacy-page">
    <div className="page-intro"><h1 data-page-heading tabIndex={-1}>Privacy</h1><p>{presentation.appName} has not published its privacy details yet.</p></div>
  </div>;
  return (
    <div className="page privacy-page">
      <div className="page-intro">
        <h1 data-page-heading tabIndex={-1}>Privacy</h1>
        <p>What WVCEA holds about you, and what happens to it.</p>
      </div>
      <div className="privacy-list">
        {PRIVACY_SECTIONS.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </section>
        ))}
        {/* Named here as well as in the store listing, so somebody reading the policy can act
            on the part of it that concerns deleting what it describes. */}
        <section>
          <h2>Deleting your account</h2>
          <p>You can delete your account and everything in it. <a className="help-action" href="/delete-account">How to delete your account<b aria-hidden="true">›</b></a></p>
        </section>
        <section>
          <h2>Contact</h2>
          <p><a className="help-action" href={`mailto:${WVCEA_EMAIL}`}>{WVCEA_EMAIL}<b aria-hidden="true">›</b></a></p>
        </section>
      </div>
      <p className="privacy-updated">Last updated {PRIVACY_UPDATED}.</p>
    </div>
  );
}
